import zh from './locales/zh.mjs'
import en from './locales/en.mjs'
import de from './locales/de.mjs'
import es from './locales/es.mjs'
import fr from './locales/fr.mjs'
import it from './locales/it.mjs'
import ja from './locales/ja.mjs'
import ko from './locales/ko.mjs'
import pt from './locales/pt.mjs'
import ptBR from './locales/pt-BR.mjs'
import staticZh from './staticLocales/zh.mjs'
import staticEn from './staticLocales/en.mjs'
import staticDe from './staticLocales/de.mjs'
import staticEs from './staticLocales/es.mjs'
import staticFr from './staticLocales/fr.mjs'
import staticIt from './staticLocales/it.mjs'
import staticJa from './staticLocales/ja.mjs'
import staticKo from './staticLocales/ko.mjs'
import staticPt from './staticLocales/pt.mjs'
import staticPtBR from './staticLocales/pt-BR.mjs'

export const supportedLocales = Object.freeze([
  'zh',
  'en',
  'de',
  'es',
  'fr',
  'it',
  'ja',
  'ko',
  'pt',
  'pt-BR'
])

export const localeOptions = Object.freeze([
  { code: 'zh', name: '简体中文' },
  { code: 'en', name: 'English' },
  { code: 'de', name: 'Deutsch' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'it', name: 'Italiano' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'pt', name: 'Português' },
  { code: 'pt-BR', name: 'Português (Brasil)' }
])

export const messagesByLocale = Object.freeze({
  zh: Object.freeze({ ...zh, ...staticZh }),
  en: Object.freeze({ ...en, ...staticEn }),
  de: Object.freeze({ ...de, ...staticDe }),
  es: Object.freeze({ ...es, ...staticEs }),
  fr: Object.freeze({ ...fr, ...staticFr }),
  it: Object.freeze({ ...it, ...staticIt }),
  ja: Object.freeze({ ...ja, ...staticJa }),
  ko: Object.freeze({ ...ko, ...staticKo }),
  pt: Object.freeze({ ...pt, ...staticPt }),
  'pt-BR': Object.freeze({ ...ptBR, ...staticPtBR })
})

export function normalizeLocale(locale) {
  if (!locale || typeof locale !== 'string') {
    return null
  }

  const normalized = locale.trim().replace('_', '-')
  if (/^pt-br$/i.test(normalized)) {
    return 'pt-BR'
  }

  const language = normalized.split('-')[0].toLowerCase()
  return supportedLocales.includes(language) ? language : null
}

export function resolveLocale({ queryLocale, savedLocale, browserLocales = [] } = {}) {
  return normalizeLocale(queryLocale)
    || normalizeLocale(savedLocale)
    || browserLocales.map(normalizeLocale).find(Boolean)
    || 'zh'
}

export function localizeUrl(value, locale) {
  const normalizedLocale = normalizeLocale(locale) || 'zh'
  const [urlWithoutHash, hash] = value.split('#', 2)

  if (hash !== undefined) {
    const [hashPath, hashQuery = ''] = hash.split('?', 2)
    const params = new URLSearchParams(hashQuery)
    params.set('lang', normalizedLocale)
    return `${urlWithoutHash}#${hashPath}?${params.toString()}`
  }

  const url = new URL(value)
  url.searchParams.set('lang', normalizedLocale)
  return url.toString()
}

export function setLocaleInUrl(value, locale) {
  const url = new URL(value)
  url.searchParams.set('lang', normalizeLocale(locale) || 'zh')
  return url.toString()
}

export function createTranslator(locale) {
  const normalizedLocale = normalizeLocale(locale) || 'zh'
  const messages = messagesByLocale[normalizedLocale]

  return (key) => messages[key] ?? messagesByLocale.zh[key] ?? key
}
